export const terminalLocation = `mutation SetTerminalLocation($address: TerminalLocationInput!) {
    setTerminalLocation(input: $address) {
      id
    }
  }
  `;
